<h2 mat-dialog-title>{{ dialogTitle }}</h2>

<mat-dialog-content>
  <p>You currently do not belong to any organization.</p>
</mat-dialog-content>

<mat-dialog-actions style="justify-content: center;">
  <button mat-button color="primary" (click)="onSave()">Close</button>
</mat-dialog-actions>